/**
 * Transactions API Service
 *
 * Handles transaction-related API calls:
 * - Get all transactions
 */

import { post } from './client';

export const transactionsApi = {
    /**
     * Get all transactions for a landlord
     * @param {string} landlordId - Landlord ID
     * @returns {Promise<Object>} List of transactions
     */
    getAll: async (landlordId) => {
        return post('pegasus/visionary/transactions/', {
            landlord_id: landlordId,
        });
    },
};

export default transactionsApi;
